import React from 'react';
import StaticPageHeader from '../components/common/StaticPageHeader';
import useMerchantSettings from '../hooks/useMerchantSettings';
import { errorView, loadingView } from '../utils/Utilities';
import { Helmet } from 'react-helmet-async';
import '../assets/css/allpages.css';

const AboutUs = () => {
    const { merchantSettings, loading, error } = useMerchantSettings();
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const storeName = merchantSettings?.legal_name || 'Online Store';

    return (
        <div className="static-page-wrapper">
            <Helmet>
                <title>{`About Us | ${storeName}`}</title>
                <meta name="description" content={`Learn more about ${storeName}, our mission, values, and quality commitment.`} />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/aboutus`} />}
            </Helmet>
            <StaticPageHeader title="About Us" />
            {loading ? loadingView() : error ? errorView(error) : (
                <div className="container static-page-container">
                    <div className="static-page-content">
                        <div dangerouslySetInnerHTML={{ __html: merchantSettings.merchant_configuration?.about_us }} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default AboutUs;